export const PAGEVIEW = 'PageView';

export const LOGIN_API_SUCCESS = 'LOGIN_API_SUCCESS';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const API_ERROR = 'API_ERROR';
export const CHATBOT_CLOSE_CLICKED = 'CHATBOT_CLOSE_CLICKED';
export const CHATBOT_EXPAND_ICON_CLICKED = 'CHATBOT_EXPAND_ICON_CLICKED';
export const CHATBOT_MINIMIZE_ICON_CLICKED = 'CHATBOT_MINIMIZE_ICON_CLICKED';

export const CONFIRMATION_MODAL_CANCEL_CLICKED =
	'CONFIRMATION_MODAL_CANCEL_CLICKED';

export const CTA_TO_NEW_REFUND_PAGE_CLICKED = 'CTA_TO_NEW_REFUND_PAGE_CLICKED';
//Dashboard Events
export const HOME_DATE_FILTER_CLOSED = 'HOME_DATE_FILTER_CLOSED';
export const HOME_DATE_FILTER_OPENED = 'HOME_DATE_FILTER_OPENED';
export const HOME_DATE_FILTER_CLICKED = 'HOME_DATE_FILTER_CLICKED';
export const HOME_DATE_SELECTED = 'HOME_DATE_SELECTED';
export const HOME_DATE_FILTER_TIME_OPENED = 'HOME_DATE_FILTER_TIME_OPENED';
export const HOME_DATE_FILTER_TIME_OK_CLICKED =
	'HOME_DATE_FILTER_TIME_OK_CLICKED';
export const HOME_DATE_FILTER_MOBILE_OPENED = 'HOME_DATE_FILTER_MOBILE_OPENED';
export const HOME_DATE_FILTER_MOBILE_CLOSED = 'HOME_DATE_FILTER_MOBILE_CLOSED';

//Login Events
export const FORGOT_PASSWORD_BUTTON_CLICKED = 'FORGOT_PASSWORD_BUTTON_CLICKED';
export const LOGIN_BUTTON_CLICKED = 'LOGIN_BUTTON_CLICKED';
export const GET_OTP_BUTTON_CLICKED = 'GET_OTP_BUTTON_CLICKED';
export const GOOGLE_PLAYSTORE_LOGO_CLICKED = 'GOOGLE_PLAYSTORE_LOGO_CLICKED';
export const APP_STORE_LOGO_CLICKED = 'APP_STORE_LOGO_CLICKED';
export const LOGIN_WITH_OTP_BUTTON_CLICKED = 'LOGIN_WITH_OTP_BUTTON_CLICKED';
export const LOGIN_WITH_EMAIL_BUTTON_CLICKED =
	'LOGIN_WITH_EMAIL_BUTTON_CLICKED';
export const LOGIN_CONTACT_LINK_CLICKED = 'LOGIN_CONTACT_LINK_CLICKED';
export const LOGIN_TERMS_AND_CONDITIONS_LINK_CLICKED =
	'LOGIN_TERMS_AND_CONDITIONS_LINK_CLICKED';
export const LOGIN_PRIVACY_POLICY_LINK_CLICKED =
	'LOGIN_PRIVACY_POLICY_LINK_CLICKED';
export const LOGIN_HELP_VIDEO_BUTTON_CLICKED =
	'LOGIN_HELP_VIDEO_BUTTON_CLICKED';
export const LOGIN_HELP_VIDEO_MODAL_CLOSED = 'LOGIN_HELP_VIDEO_MODAL_CLOSED';
export const LOGIN_PG_BANNER_CLICKED = 'LOGIN_PG_BANNER_CLICKED';
export const PG_LOGIN_HELP_BUTTON_CLICKED = 'PG_LOGIN_HELP_BUTTON_CLICKED';
export const SIGN_UP_COMPLETED = 'SIGN_UP_COMPLETED';

//Login/Verify OTP Events
export const VERIFY_OTP_BUTTON_CLICKED = 'VERIFY_OTP_BUTTON_CLICKED';
export const RESEND_OTP_BUTTON_CLICKED = 'RESEND_OTP_BUTTON_CLICKED';
export const VERIFY_OTP_DRAWER_CLOSED = 'VERIFY_OTP_DRAWER_CLOSED';

//Login/Group Selection Screen Events
export const GROUP_SELECTION_BACK_BUTTON_CLICKED =
	'GROUP_SELECTION_BACK_BUTTON_CLICKED';
export const GROUP_SELECTION_LIST_ITEM_CLICKED =
	'GROUP_SELECTION_LIST_ITEM_CLICKED';

//Forgot Password events
export const FORGOT_PASSWORD_CANCEL_CLICKED = 'FORGOT_PASSWORD_CANCEL_CLICKED';
export const FORGOT_PASSWORD_SUBMIT_CLICKED = 'FORGOT_PASSWORD_SUBMIT_CLICKED';
export const FORGOT_PASSWORD_CROSS_ICON_CLICKED =
	'FORGOT_PASSWORD_SUBMIT_CLICKED';
export const FORGOT_PASSWORD_SUCCESS_CROSS_ICON_CLICKED =
	'FORGOT_PASSWORD_SUCCESS_CROSS_ICON_CLICKED';

//Set Password events
export const SET_PASSWORD_REDIRECT_LOGIN_CLICKED =
	'SET_PASSWORD_REDIRECT_LOGIN_CLICKED';
export const SET_PASSWORD_SUBMIT_BUTTON_CLICKED =
	'SET_PASSWORD_SUBMIT_BUTTON_CLICKED';
export const SET_PASSWORD_LINK_EXPIRED = 'SET_PASSWORD_LINK_EXPIRED';
export const SET_PASSWORD_SUCCESSFULL_REDIRECTION =
	'SET_PASSWORD_SUCCESSFULL_REDIRECTION';

//User Verify events
export const USER_VERIFY_REDIRECT_LOGIN_CLICKED =
	'USER_VERIFY_REDIRECT_LOGIN_CLICKED';
export const USER_VERIFY_ERROR_LOGIN_CLICKED =
	'USER_VERIFY_ERROR_LOGIN_CLICKED';
export const USER_VERIFICATION_REQUESTED = 'USER_VERIFICATION_REQUESTED';
export const USER_VERIFICATION_SUCCESS = 'USER_VERIFICATION_SUCCESS';
export const USER_VERIFICATION_FAILED = 'USER_VERIFICATION_FAILED';

export const LOGOUT_BUTTON_CLICKED = 'LOGOUT_BUTTON_CLICKED';
export const VIEW_PROFILE_BUTTON_CLICKED = 'VIEW_PROFILE_BUTTON_CLICKED';
export const MOBILE_MENU_CLICKED = 'MOBILE_MENU_CLICKED';
export const TOPNAV_AVATAR_CLICKED = 'TOPNAV_AVATAR_CLICKED';
export const TOPNAV_SEARCH_FOCUSED = 'TOPNAV_SEARCH_FOCUSED';
export const TOPNAV_SEARCH_ENTERED = 'TOPNAV_SEARCH_ENTERED';
export const CHANGE_STORE_BUTTON_CLICKED = 'CHANGE_STORE_BUTTON_CLICKED';
export const BUSINESS_CHANGE_OPTION_SELECTED =
	'BUSINESS_CHANGE_OPTION_SELECTED';
//Side navbar Events
export const HOME_TAB_CLICKED = 'HOME_TAB_CLICKED';
export const TRANSACTION_TAB_CLICKED = 'TRANSACTION_TAB_CLICKED';
export const SETTLEMENTS_TAB_CLICKED = 'SETTLEMENTS_TAB_CLICKED';
export const QR_TAB_CLICKED = 'QR_TAB_CLICKED';
export const STORES_TAB_CLICKED = 'STORES_TAB_CLICKED';
export const USERS_TAB_CLICKED = 'USERS_TAB_CLICKED';
export const TRAINING_TAB_CLICKED = 'TRAINING_TAB_CLICKED';
export const HELP_TAB_CLICKED = 'HELP_TAB_CLICKED';
export const DEV_SETTINGS_TAB_CLICKED = 'DEV_SETTINGS_TAB_CLICKED';

//Manage Users Events
export const ADD_NEW_USER_INITIATED = 'ADD_NEW_USER_INITIATED';
export const ADD_NEW_USER_MODAL_OPENED = 'ADD_NEW_USER_MODAL_OPENED';
export const ADD_NEW_USER_MODAL_CANCEL_CLICKED =
	'ADD_NEW_USER_MODAL_CANCEL_CLICKED';
export const ADD_NEW_USER_BUTTON_CLICKED = 'ADD_NEW_USER_BUTTON_CLICKED';
export const EDIT_USER_ROLE_MODAL_OPENED = 'EDIT_USER_ROLE_MODAL_OPENED';
export const EDIT_USER_MODAL_CANCEL_CLICKED = 'EDIT_USER_MODAL_CANCEL_CLICKED';
export const EDIT_USER_DETAILS_UPDATED = 'EDIT_USER_DETAILS_UPDATED';
export const DELETE_USER_BUTTON_CLICKED = 'DELETE_USER_BUTTON_CLICKED';
export const DELETE_USER_MODAL_CANCEL_CLICKED =
	'DELETE_USER_MODAL_CANCEL_CLICKED';
export const DELETE_USER_MODAL_OPENED = 'DELETE_USER_MODAL_OPENED';
export const EDIT_USER_LINKED_STORE_MODAL_OPENED =
	'EDIT_USER_LINKED_STORE_MODAL_OPENED';
export const EDIT_USER_LINKED_STORE_OK_CLICKED =
	'EDIT_USER_LINKED_STORE_OK_CLICKED';
export const EDIT_LINKED_STORE_MODAL_SEARCH_FOCUSED =
	'EDIT_LINKED_STORE_MODAL_SEARCH_FOCUSED';
export const EDIT_LINKED_STORE_MODAL_TOGGLE_CLICKED =
	'EDIT_LINKED_STORE_MODAL_TOGGLE_CLICKED';
export const EDIT_LINKED_STORE_MODAL_STORE_ITEM_CLICKED =
	'EDIT_LINKED_STORE_MODAL_STORE_ITEM_CLICKED';

//Daily Transaction reports Events
export const TRANSACTION_DAILY_REPORT_MONTHVIEW_CLICKED =
	'TRANSACTION_DAILY_REPORT_MONTHVIEW_CLICKED';
export const TRANSACTION_DAILY_REPORT_DOWNLOAD_CLICKED =
	'TRANSACTION_DAILY_REPORT_DOWNLOAD_CLICKED';
export const TRANSACTION_DAILY_REPORT_TAB_CLICKED =
	'TRANSACTION_DAILY_REPORT_TAB_CLICKED';

//Transaction Reports Events
export const TRANSACTION_GENERATE_REPORT_BUTTON_CLICKED =
	'TRANSACTION_GENERATE_REPORT_BUTTON_CLICKED';
export const TRANSACTION_REPORT_DOWNLOAD_CLICKED =
	'TRANSACTION_REPORT_DOWNLOAD_CLICKED';
export const TRANSACTION_GENERATE_REPORT_RESET_BUTTON_CLICKED =
	'TRANSACTION_GENERATE_REPORT_RESET_BUTTON_CLICKED';
export const TRANSACTION_GENERATE_REPORT_CANCEL_BUTTON_CLICKED =
	'TRANSACTION_GENERATE_REPORT_CANCEL_BUTTON_CLICKED';
export const TRANSACTION_REPORT_TAB_CLICKED = 'TRANSACTION_REPORT_TAB_CLICKED';
export const TRANSACTION_GENERATE_REPORT_CLICKED =
	'TRANSACTION_GENERATE_REPORT_CLICKED';
export const TRANSACTION_REPORT_INSTRUMENT_FILTER_OPTIONS_CLICKED =
	'TRANSACTION_REPORT_INSTRUMENT_FILTER_OPTIONS_CLICKED';
export const TRANSACTION_REPORT_STATUS_FILTER_OPTIONS_CLICKED =
	'TRANSACTION_REPORT_STATUS_FILTER_OPTIONS_CLICKED';
export const TRANSACTION_REPORT_MERCHANT_LIST_SELECTED =
	'TRANSACTION_REPORT_MERCHANT_LIST_SELECTED';

//QMC Report Events
export const QMC_REPORTS_TAB_CLICKED = 'QMC_REPORTS_TAB_CLICKED';

//Transaction Detail Events
export const INITIATE_REFUND_BUTTON_CLICKED = 'INITIATE_REFUND_BUTTON_CLICKED';
export const REFUND_CONFIRMATION_MODAL_OPENED =
	'REFUND_CONFIRMATION_MODAL_OPENED';
export const REFUND_TOGGLE_SWITCH_CLICKED = 'REFUND_TOGGLE_SWITCH_CLICKED';
export const REFUND_PAYMENT_MODAL_CANCEL_CLICKED =
	'REFUND_PAYMENT_MODAL_CANCEL_CLICKED';
export const REFUND_INITIATED = 'REFUND_INITIATED';
export const TRANSACTION_HELP_BUTTON_CLICKED =
	'TRANSACTION_HELP_BUTTON_CLICKED';

//Transaction History List Events
export const TRANSACTION_DATE_FILTER_CLOSED = 'TRANSACTION_DATE_FILTER_CLOSED';
export const TRANSACTION_DATE_FILTER_OPENED = 'TRANSACTION_DATE_FILTER_OPENED';
export const TRANSACTION_DATE_FILTER_CLICKED =
	'TRANSACTION_DATE_FILTER_CLICKED';
export const TRANSACTION_DATE_SELECTED = 'TRANSACTION_DATE_SELECTED';
export const TRANSACTION_FILTER_SELECTED = 'TRANSACTION_FILTER_SELECTED';
export const TRANSACTION_FILTER_RESET_CLICKED =
	'TRANSACTION_FILTER_RESET_CLICKED';
export const TRANSACTION_FILTER_CLOSED = 'TRANSACTION_FILTER_CLOSED';
export const TRANSACTION_FILTER_OPENED = 'TRANSACTION_FILTER_OPENED';
export const TRANSACTION_CUSTOM_COLUMN_SELECTED =
	'TRANSACTION_CUSTOM_COLUMN_SELECTED';
export const TRANSACTION_CUSTOM_COLUMN_CANCEL_CLICKED =
	'TRANSACTION_CUSTOM_COLUMN_CANCEL_CLICKED';
export const TRANSACTION_CUSTOM_COLUMN_CLOSED =
	'TRANSACTION_CUSTOM_COLUMN_CLOSED';
export const TRANSACTION_CUSTOM_COLUMN_OPENED =
	'TRANSACTION_CUSTOM_COLUMN_OPENED';
export const TRANSACTION_CUSTOM_COLUMN_SHOW_ALL =
	'TRANSACTION_CUSTOM_COLUMN_SHOW_ALL';
export const TRANSACTION_PRINT_SUMARY_CLICKED =
	'TRANSACTION_PRINT_SUMARY_CLICKED';
export const TRANSACTION_LIST_FILTER_REMOVED =
	'TRANSACTION_LIST_FILTER_REMOVED';
export const TRANSACTION_LIST_ROW_CLICKED = 'TRANSACTION_LIST_ROW_CLICKED';
export const TRANSACTION_COPY_CLICKED = 'TRANSACTION_COPY_CLICKED';
export const VIEW_LIVE_TRANSACTIONS_BUTTON_CLICKED =
	'VIEW_LIVE_TRANSACTIONS_BUTTON_CLICKED';
export const TRANSACTION_LIST_TAB_CLICKED = 'TRANSACTION_LIST_TAB_CLICKED';
export const TRANSACTION_REPORTS_TAB_CLICKED =
	'TRANSACTION_REPORTS_TAB_CLICKED';
export const TRANSACTION_REFUNDS_TAB_CLICKED =
	'TRANSACTION_REFUNDS_TAB_CLICKED';
export const LIVE_TRANSACTIONS_TAB_CLICKED = 'LIVE_TRANSACTIONS_TAB_CLICKED';
export const TRANSACTION_DAILY_REPORTS_TAB_CLICKED =
	'TRANSACTION_DAILY_REPORTS_TAB_CLICKED';
export const TXN_HISTORY_REFRESH_TRANSACTIONS =
	'TXN_HISTORY_REFRESH_TRANSACTIONS';
export const TXN_HISTORY_SEARCH_CLICK = 'TXN_HISTORY_SEARCH_CLICK';
export const TXN_HISTORY_SEARCH = 'TXN_HISTORY_SEARCH';
export const TXN_HISTORY_SEARCH_CLEAR = 'TXN_HISTORY_SEARCH_CLEAR';
export const TXN_HISTORY_COPY_UTR = 'TXN_HISTORY_COPY_UTR';

//Live Transaction events
export const LIVE_TRANSACTIONS_RELOAD_CLICKED =
	'LIVE_TRANSACTIONS_RELOAD_CLICKED';
export const VIEW_TRANSACTION_HISTORY_BUTTON_CLICKED =
	'VIEW_TRANSACTION_HISTORY_BUTTON_CLICKED';
export const LIVE_TRANSACTIONS_COPY_TID_CLICKED =
	'LIVE_TRANSACTIONS_COPY_TID_CLICKED';
export const LIVE_TRANSACTIONS_COPY_TID_SUCCEEDED =
	'LIVE_TRANSACTIONS_COPY_TID_SUCCEEDED';
export const LIVE_TRANSACTIONS_COPY_TID_FAILED =
	'LIVE_TRANSACTIONS_COPY_TID_FAILED';
export const LIVE_TRANSACTIONS_COPY_UTR_CLICKED =
	'LIVE_TRANSACTIONS_COPY_UTR_CLICKED';
export const LIVE_TRANSACTIONS_COPY_UTR_SUCCEEDED =
	'LIVE_TRANSACTIONS_COPY_UTR_SUCCEEDED';
export const LIVE_TRANSACTIONS_COPY_UTR_FAILED =
	'LIVE_TRANSACTIONS_COPY_UTR_FAILED';
export const LIVE_TXN_FILTER_APPLIED = 'TRANSACTION_FILTER_APPLIED';
export const LIVE_TXN_FILTER_PILL_CROSS_CLICKED =
	'TRANSACTION_FILTER_PILL_CROSS_CLICKED';
export const LIVE_TXN_FILTER_RESET_CLICKED = 'TRANSACTION_FILTER_RESET_CLICKED';
export const LIVE_TXN_FILTER_CLOSED = 'TRANSACTION_FILTER_CLOSED';
export const LIVE_TXN_FILTER_OPENED = 'TRANSACTION_FILTER_OPENED';

// Settlements events
export const RECENT_SETTLEMENTS_VIEWED = 'RECENT_SETTLEMENTS_VIEWED';
export const OLDER_SETTLEMENTS_VIEWED = 'OLDER_SETTLEMENTS_VIEWED';
export const SELECTED_SETTLEMENT_DRAWER_OPENED =
	'SELECTED_SETTLEMENT_DRAWER_OPENED';
export const SETTLEMENTS_HELP_MODAL_OPENED = 'SETTLEMENTS_HELP_MODAL_OPENED';
export const SETTLEMENTS_HELP_MODAL_CLOSED = 'SETTLEMENTS_HOLIDAY_MODAL_CLOSED';
export const SETTLEMENTS_HOLIDAY_MODAL_OPENED =
	'SETTLEMENTS_HOLIDAY_MODAL_OPENED';
export const SETTLEMENTS_HOLIDAY_MODAL_CLOSED =
	'SETTLEMENTS_HOLIDAY_MODAL_CLOSED';
export const SETTLEMENTS_GST_DOWNLOAD_MODAL_OPENED =
	'SETTLEMENTS_GST_DOWNLOAD_MODAL_OPENED';
export const SETTLEMENTS_GST_DOWNLOAD_MODAL_CLOSED =
	'SETTLEMENTS_GST_DOWNLOAD_MODAL_CLOSED';
export const SETTLEMENTS_REPORT_DOWNLOADED = 'SETTLEMENTS_REPORT_DOWNLOADED';
export const RECENT_SETTLEMENTS_MONTHLY_REPORT_CLICKED =
	'RECENT_SETTLEMENTS_MONTHLY_REPORT_CLICKED';
export const SETTLEMENTS_MONTHLY_REPORT_CLICKED =
	'SETTLEMENTS_MONTHLY_REPORT_CLICKED';
export const SETTLEMENT_UTR_COPY_CLICKED = 'SETTLEMENT_UTR_COPY_CLICKED';
export const SETTLEMENT_HELP_EMAIL_CLICKED = 'SETTLEMENT_HELP_EMAIL_CLICKED';
export const SELECTED_SETTLEMENT_DRAWER_DOWNLOAD_CLICKED =
	'SELECTED_SETTLEMENT_DRAWER_DOWNLOAD_CLICKED';
export const SELECTED_SETTLEMENT_DRAWER_GENERATE_CLICKED =
	'SELECTED_SETTLEMENT_DRAWER_GENERATE_CLICKED';

//Mapped QR
export const MAPPED_QR_ENABLED_TAB_CLICKED = 'MAPPED_QR_ENABLED_TAB_CLICKED';
export const MAPPED_QR_DISABLE_TAB_CLICKED = 'MAPPED_QR_DISABLE_TAB_CLICKED';

//Mapped QR/Enabled QR
export const MAPPED_QR_FILTERS_CANCEL_CLICKED =
	'MAPPED_QR_FILTERS_CANCEL_CLICKED';
export const MAPPED_QR_FILTERS_CLOSED = 'MAPPED_QR_FILTERS_CLOSED';
export const MAPPED_QR_FILTERS_OPENED = 'MAPPED_QR_FILTERS_OPENED';
export const MAPPED_QR_FILTERS_APPLY_CLICKED =
	'MAPPED_QR_FILTERS_APPLY_CLICKED';
export const MAPPED_QR_LIST_ITEM_CLOSED = 'MAPPED_QR_LIST_ITEM_CLOSED';
export const MAPPED_QR_LIST_ITEM_OPENED = 'MAPPED_QR_LIST_ITEM_OPENED';
export const MAPPED_QR_LIST_ITEM_QR_DOWNLOAD_CLICKED =
	'MAPPED_QR_LIST_ITEM_QR_DOWNLOAD_CLICKED';
export const ADD_NOTIFICATION_RECEIVER_CLICKED =
	'ADD_NOTIFICATION_RECEIVER_CLICKED';
export const ADD_NOTIFICATION_MODAL_VERIFY_CLICKED =
	'ADD_NOTIFICATION_MODAL_VERIFY_CLICKED';
export const ADD_NOTIFICATION_MODAL_RESEND_OTP_CLICKED =
	'ADD_NOTIFICATION_MODAL_RESEND_OTP_CLICKED';
export const ADD_NOTIFICATION_MODAL_CONFIRM_CLICKED =
	'ADD_NOTIFICATION_MODAL_CONFIRM_CLICKED';
export const ADD_NOTIFICATION_MODAL_TOGGLE_CLICKED =
	'ADD_NOTIFICATION_MODAL_TOGGLE_CLICKED';
export const ADD_NOTIFICATION_MODAL_CANCEL_CLICKED =
	'ADD_NOTIFICATION_MODAL_CANCEL_CLICKED';
export const NOTIFICATION_RECEIVER_DELETE_CLICKED =
	'NOTIFICATION_RECEIVER_DELETE_CLICKED';

//Mapped QR/Disabled QR

//Manage Store events
export const STORE_ADD_PHOTOS_MODAL_ADD_PHOTOS_CLICKED =
	'STORE_ADD_PHOTOS_MODAL_ADD_PHOTOS_CLICKED';
export const STORE_ADD_PHOTOS_MODAL_CLOSE_CLICKED =
	'STORE_ADD_PHOTOS_MODAL_CLOSE_CLICKED';
export const STORE_ADD_PHOTOS_MODAL_INFO_ICON_CLICKED =
	'STORE_ADD_PHOTOS_MODAL_INFO_ICON_CLICKED';
export const STORE_ADD_PHOTOS_MODAL_INFO_CLOSE_CLICKED =
	'STORE_ADD_PHOTOS_MODAL_INFO_CLOSE_CLICKED';
export const STORE_ADD_PHOTOS_MODAL_DELETE_CLICKED =
	'STORE_ADD_PHOTOS_MODAL_DELETE_CLICKED';
export const STORE_DETAILS_ADDRESS_MODAL_CANCEL_CLICKED =
	'STORE_DETAILS_ADDRESS_MODAL_CANCEL_CLICKED';
export const STORE_DETAILS_ADDRESS_MODAL_SAVE_CLICKED =
	'STORE_DETAILS_ADDRESS_MODAL_SAVE_CLICKED';
export const STORE_DETAILS_OTP_MODAL_RESEND_OTP_CLICKED =
	'STORE_DETAILS_OTP_MODAL_RESEND_OTP_CLICKED';
export const STORE_DETAILS_OTP_MODAL_VERIFY_CLICKED =
	'STORE_DETAILS_OTP_MODAL_VERIFY_CLICKED';
export const STORE_DETAILS_BACK_CLICKED = 'STORE_DETAILS_BACK_CLICKED';
export const STORE_DETAILS_OTP_MODAL_CLOSE_CLICKED =
	'STORE_DETAILS_OTP_MODAL_CLOSE_CLICKED';
export const STORE_DETAILS_BANNER_ADD_PHOTOS_CLICKED =
	'STORE_DETAILS_BANNER_ADD_PHOTOS_CLICKED';
export const STORE_DETAILS_VIEW_STORE_CLICKED =
	'STORE_DETAILS_VIEW_STORE_CLICKED';
export const STORE_IMAGE_OPENED = 'STORE_IMAGE_OPENED';
export const STORE_DETAILS_EDIT_STORE_NAME_CLICKED =
	'STORE_DETAILS_EDIT_STORE_NAME_CLICKED';
export const STORE_DETAILS_ADD_NUMBER_CLICKED =
	'STORE_DETAILS_ADD_NUMBER_CLICKED';
export const STORE_DETAILS_EDIT_NUMBER_CLICKED =
	'STORE_DETAILS_EDIT_NUMBER_CLICKED';
export const STORE_DETAILS_ADD_ADDRESS_CLICKED =
	'STORE_DETAILS_ADD_ADDRESS_CLICKED';
export const STORE_DETAILS_EDIT_ADDRESS_CLICKED =
	'STORE_DETAILS_EDIT_ADDRESS_CLICKED';
export const STORE_DETAILS_ADD_PHOTOS_CLICKED =
	'STORE_DETAILS_ADD_PHOTOS_CLICKED';
export const STORE_PHONE_NUMBER_UPDATE_MODAL_CANCEL_CLICKED =
	'STORE_PHONE_NUMBER_UPDATE_MODAL_CANCEL_CLICKED';
export const STORE_PHONE_NUMBER_UPDATE_MODAL_SAVE_CLICKED =
	'STORE_PHONE_NUMBER_UPDATE_MODAL_SAVE_CLICKED';
export const STORE_NAME_UPDATE_MODAL_CANCEL_CLICKED =
	'STORE_NAME_UPDATE_MODAL_CANCEL_CLICKED';
export const STORE_NAME_UPDATE_MODAL_SAVE_CLICKED =
	'STORE_NAME_UPDATE_MODAL_SAVE_CLICKED';
export const STORE_LIST_ITEM_CLICKED = 'STORE_LIST_ITEM_CLICKED';
export const STORE_LIST_CLEAR_BTN_CLICKED = 'STORE_LIST_CLEAR_BTN_CLICKED';
export const STORE_SEARCH_ID_SUCCESS = 'STORE_SEARCH_ID_SUCCESS';
export const STORE_LIST_SEARCH_FAILURE = 'STORE_LIST_SEARCH_FAILURE';

//Profile Events
export const PROFILE_ADDRESS_MODAL_CANCEL_CLICKED =
	'PROFILE_ADDRESS_MODAL_CANCEL_CLICKED';
export const PROFILE_ADDRESS_MODAL_SAVE_CLICKED =
	'PROFILE_ADDRESS_MODAL_SAVE_CLICKED';
export const EDIT_NAME_MODAL_CANCEL_CLICKED = 'EDIT_NAME_MODAL_CANCEL_CLICKED';
export const EDIT_NAME_MODAL_SAVE_CLICKED = 'EDIT_NAME_MODAL_SAVE_CLICKED';
export const RESET_PASSWORD_BUTTON_CLICKED = 'RESET_PASSWORD_BUTTON_CLICKED';
export const PROFILE_EDIT_NAME_ICON_CLICKED = 'PROFILE_EDIT_NAME_ICON_CLICKED';
export const PROFILE_EDIT_EMAIL_ICON_CLICKED =
	'PROFILE_EDIT_EMAIL_ICON_CLICKED';
export const PROFILE_EDIT_ADDRESS_ICON_CLICKED =
	'PROFILE_EDIT_ADDRESS_ICON_CLICKED';
export const PROFILE_ADDRESS_UPDATED_SUCCESSFULLY =
	'PROFILE_ADDRESS_UPDATED_SUCCESSFULLY';
export const PROFILE_NAME_UPDATED_SUCCESSFULLY =
	'PROFILE_NAME_UPDATED_SUCCESSFULLY';
export const OTP_FOR_EMAIL_UPDATE_SENT = 'OTP_FOR_EMAIL_UPDATE_SENT';
export const SENDING_OTP_FOR_EMAIL_UPDATE_FAILED =
	'SENDING_OTP_FOR_EMAIL_UPDATE_FAILED';
export const OTP_VERIFIED_FOR_EMAIL_UPDATE = 'OTP_VERIFIED_FOR_EMAIL_UPDATE';
export const OTP_VERIFICATION_FAILED_FOR_EMAIL_UPDATE =
	'OTP_VERIFICATION_FAILED_FOR_EMAIL_UPDATE';
export const ADDRESS_UPDATE_MODAL_CLOSED = 'ADDRESS_UPDATE_MODAL_CLOSED';
export const BUSINESS_NAME_UPDATE_MODAL_CLOSED =
	'BUSINESS_NAME_UPDATE_MODAL_CLOSED';
export const EMAIL_UPDATE_OTP_MODAL_CLOSED = 'EMAIL_UPDATE_OTP_MODAL_CLOSED';
export const SHOW_OTP_MODAL_CLOSED = 'SHOW_OTP_MODAL_CLOSED';

//Refunds Events
export const REFUNDS_FILTER_REMOVED = 'REFUNDS_FILTER_REMOVED';
export const VIEW_PAST_REFUNDS_TAB_CLICKED = 'VIEW_PAST_REFUNDS_TAB_CLICKED';
export const INITIATE_REFUNDS_TAB_CLICKED = 'INITIATE_REFUNDS_TAB_CLICKED';
export const REFUNDS_REPORTS_TAB_CLICKED = 'REFUNDS_REPORTS_TAB_CLICKED';
export const REFUNDS_DAILY_REPORTS_TAB_CLICKED =
	'REFUNDS_DAILY_REPORTS_TAB_CLICKED';
export const REFUNDS_TAB_CLICKED = 'REFUNDS_TAB_CLICKED';
export const REFUNDS_FILTER_RESET_CLICKED = 'REFUNDS_FILTER_RESET_CLICKED';
export const REFUNDS_FILTER_CANCEL_CLICKED = 'REFUNDS_FILTER_CANCEL_CLICKED';
export const REFUNDS_FILTER_SELECTED = 'REFUNDS_FILTER_SELECTED';
export const REFUNDS_FILTER_CLOSED = 'REFUNDS_FILTER_CLOSED';
export const REFUNDS_FILTER_OPENED = 'REFUNDS_FILTER_OPENED';
export const REFUNDS_DATE_SELECTED = 'REFUNDS_DATE_SELECTED';
export const REFUNDS_ROW_CLICKED = 'REFUNDS_ROW_CLICKED';
export const REFUNDS_DATE_FILTER_CLOSED = 'REFUNDS_DATE_FILTER_CLOSED';
export const REFUNDS_DATE_FILTER_OPENED = 'REFUNDS_DATE_FILTER_OPENED';
export const TRANSACTION_DETAILS_REFUND_DRAWER_CLICKED =
	'TRANSACTION_DETAILS_REFUND_DRAWER_CLICKED';

// Refund Reports Events
export const REFUNDS_REPORTS_DOWNLOAD_CLICKED =
	'REFUNDS_REPORTS_DOWNLOAD_CLICKED';
export const REFUNDS_REPORTS_GENERATE_REPORT_CLICKED =
	'REFUNDS_REPORTS_GENERATE_REPORT_CLICKED';
export const REFUND_GENERATE_REPORT_CLICKED = 'REFUND_GENERATE_REPORT_CLICKED';
export const REFUND_GENERATE_REPORT_CANCEL_BUTTON_CLICKED =
	'REFUND_GENERATE_REPORT_CANCEL_BUTTON_CLICKED';
export const REFUND_GENERATE_REPORT_RESET_BUTTON_CLICKED =
	'REFUND_GENERATE_REPORT_RESET_BUTTON_CLICKED';
export const REFUND_REPORT_INSTRUMENT_FILTER_OPTIONS_CLICKED =
	'REFUND_REPORT_INSTRUMENT_FILTER_OPTIONS_CLICKED';
export const REFUND_REPORT_STATUS_FILTER_OPTIONS_CLICKED =
	'REFUND_REPORT_STATUS_FILTER_OPTIONS_CLICKED';
export const REFUND_REPORT_MERCHANT_LIST_SELECTED =
	'REFUND_REPORT_MERCHANT_LIST_SELECTED';

//Refunds/Daily Reports
export const REFUNDS_DAILY_REPORT_DOWNLOAD_CLICKED =
	'REFUNDS_DAILY_REPORT_DOWNLOAD_CLICKED';
export const REFUNDS_DAILY_REPORT_MONTH_VIEW_CLOSED =
	'REFUNDS_DAILY_REPORT_MONTH_VIEW_CLOSED';
export const REFUNDS_DAILY_REPORT_MONTH_VIEW_OPENED =
	'REFUNDS_DAILY_REPORT_MONTH_VIEW_OPENED';

//Refunds/Initiate Refunds
export const INITIATE_REFUNDS_INFO_ICON_CLICKED =
	'INITIATE_REFUNDS_INFO_ICON_CLICKED';
export const INITIATE_REFUNDS_UPLOAD_LIST_CLICKED =
	'INITIATE_REFUNDS_UPLOAD_LIST_CLICKED';
export const INITIATE_REFUNDS_SAMPLE_DOCUMENT_CLICKED =
	'INITIATE_REFUNDS_SAMPLE_DOCUMENT_CLICKED';
export const INITIATE_REFUNDS_UPLOADED_FILE_DOWNLOAD_CLICKED =
	'INITIATE_REFUNDS_UPLOADED_FILE_DOWNLOAD_CLICKED';
export const INITIATE_REFUNDS_REPORT_DOWNLOAD_CLICKED =
	'INITIATE_REFUNDS_REPORT_DOWNLOAD_CLICKED';
export const INITIATE_REFUNDS_INFO_MODAL_CLOSE_CLICKED =
	'INITIATE_REFUNDS_INFO_MODAL_CLOSE_CLICKED';

//Merchant announcement events
export const NOTIFICATION_BAR_SHOWN = 'NOTIFICATION_BAR_SHOWN';
export const NOTIFICATION_BAR_DISMISSED = 'NOTIFICATION_BAR_DISMISSED';

//Supermerchant Select Events
export const MERCHANT_SELECT_MODAL_OPENED = 'MERCHANT_SELECT_OPENED';
export const MERCHANT_SELECT_MODAL_CLOSED = 'MERCHANT_SELECT_CLOSED';
export const MERCHANT_SELECT_MODAL_APPLY_CLICKED =
	'MERCHANT_SELECT_APPLY_CLICKED';
export const MERCHANT_SELECT__MODAL_CLEAR_CLICKED =
	'MERCHANT_SELECT_CLEAR_CLICKED';

// FAQ events
export const CHAT_BOT_OPENED = 'CHAT_BOT_OPENED';
export const OPEN_TICKETS_VIEWED = 'OPEN_TICKETS_VIEWED';

//Transaction details
export const TD_FAILED_PAYMENTS_TRANSACTION_NUMBER_COPIED =
	'TD_FAILED_PAYMENTS_TRANSACTION_NUMBER_COPIED';
export const TD_OFFER_ID_COPIED = 'TD_OFFER_ID_COPIED';
export const TD_UTR_NUMBER_COPIED = 'TD_UTR_NUMBER_COPIED';
export const TD_OVERVIEW_DATA_COPIED = 'TD_OVERVIEW_DATA_COPIED';
export const TD_SUBSCRIPTION_DATA_COPIED = 'TD_SUBSCRIPTION_DATA_COPIED';
export const TD_REFUND_UTR_NUMBER_COPIED = 'TD_REFUND_UTR_NUMBER_COPIED';
export const TD_REFUND_BUTTON_CLICKED = 'TD_REFUND_CTA_CLICKED';
export const TD_CONTACT_SUPPORT_CLICKED = 'TD_CONTACT_SUPPORT_CLICKED';
export const TD_NAVBAR_CLICKED = 'TD_NAVBAR_CLICKED';
export const TD_REFUND_TXN_NUMBER_COPIED = 'TD_REFUND_TXN_NUMBER_COPIED';
export const TD_REFUND_MODAL_CLOSE_CTA_CLICKED =
	'TD_REFUND_MODAL_CLOSE_CTA_CLICKED';
export const TD_REFUND_INITIATE_CTA_CLICKED = 'TD_REFUND_INITIATE_CTA_CLICKED';

// Coachmark events
export const TOUR_STARTED = 'TOUR_STARTED';
export const TOUR_SKIPPED = 'TOUR_SKIPPED';
export const TOUR_CLOSED = 'TOUR_CLOSED';
export const COACHMARK_VIEWED = 'COACHMARK_VIEWED';

//Notification events
export const PUSH_NOTIFICATION_CLICK = 'PUSH_NOTIFICATION_CLICK';
export const PUSH_NOTIFICATION_DRAWER_CLOSED =
	'PUSH_NOTIFICATION_DRAWER_CLOSED';
export const PN_INBOX_PAGE_LOAD = 'PN_INBOX_PAGE_LOAD';
export const PN_NOTIF_CLICK = 'PN_NOTIF_CLICK';

//Date Picker
export const DATE_RANGE_PICKER_THIS_MONTH_SELECTED =
	'DATE_RANGE_PICKER_THIS_MONTH_SELECTED';
export const DATE_RANGE_PICKER_PAST_6_MONTHS_SELECTED =
	'DATE_RANGE_PICKER_PAST_6_MONTHS_SELECTED';
export const DATE_RANGE_PICKER_THIS_WEEK_SELECTED =
	'DATE_RANGE_PICKER_THIS_WEEK_SELECTED';
export const DATE_RANGE_PICKER_TODAY_SELECTED =
	'DATE_RANGE_PICKER_TODAY_SELECTED';
export const DATE_RANGE_PICKER_YESTERDAY_SELECTED =
	'DATE_RANGE_PICKER_YESTERDAY_SELECTED';
export const DATE_RANGE_PICKER_CUSTOM_DATE_SELECTED =
	'DATE_RANGE_PICKER_CUSTOM_DATE_SELECTED';
// Developer Settings
export const API_KEYS_COPIED = 'API_KEYS_COPIED';
export const API_KEY_TAB_CLICKED = 'API_KEY_TAB_CLICKED';
export const WEBHOOK_TAB_CLICKED = 'WEBHOOK_TAB_CLICKED';
export const WEBHOOK_ROW_DETAIL_OPENED = 'WEBHOOK_ROW_DETAIL_OPENED';
export const WEBHOOK_ROW_DETAIL_CLOSED = 'WEBHOOK_ROW_DETAIL_CLOSED';
export const WEBHOOK_ROW_DELETE_CLICKED = 'WEBHOOK_ROW_DELETE_CLICKED';
export const WEBHOOK_EDIT_MODAL_OPENED = 'WEBHOOK_EDIT_MODAL_OPENED';
export const WEBHOOK_EDIT_MODAL_CLOSED = 'WEBHOOK_EDIT_MODAL_CLOSED';
export const WEBHOOK_CREATE_MODAL_OPENED = 'WEBHOOK_CREATE_MODAL_OPENED';
export const WEBHOOK_CREATE_MODAL_CLOSED = 'WEBHOOK_CREATE_MODAL_CLOSED';
export const WEBHOOK_CREATED = 'WEBHOOK_CREATED';
export const WEBHOOK_UPDATED = 'WEBHOOK_UPDATED';
export const WEBHOOK_DELETE_CONFIRM_MODAL_OPENED =
	'WEBHOOK_DELETE_CONFIRM_MODAL_OPENED';
export const WEBHOOK_DELETE_CONFIRM_MODAL_CLOSED =
	'WEBHOOK_DELETE_CONFIRM_MODAL_CLOSED';
export const API_CLIENT_KEYS_COPIED = 'API_CLIENT_KEYS_COPIED';
export const TEST_MODE_SET = 'TEST_MODE_SET';
export const API_TEST_KEYS_FETCHED = 'API_TEST_KEYS_FETCHED';

// Common Paylink events
export const PAYLINK_PAGINATION_CLICKED = 'PAYLINK_PAGINATION_CLICKED';
export const PAYLINK_CREATE_BUTTON_CLICKED = 'PAYLINK_CREATE_BUTTON_CLICKED';
export const PAYLINK_DETAIL_DRAWER_CLOSED = 'PAYLINK_DETAIL_DRAWER_CLOSED';
export const PAYLINK_CANCEL_CLICKED = 'PAYLINK_CANCEL_CLICKED';
export const PAYLINK_CANCEL_SUCCEEDED = 'PAYLINK_CANCEL_SUCCEEDED';
export const PAYLINK_CANCEL_FAILED = 'PAYLINK_CANCEL_FAILED';
export const PAYLINK_COPY_LINK_CLICKED = 'PAYLINK_COPY_LINK_CLICKED';
export const PAYLINK_FILTER_RESET_CLICKED = 'PAYLINK_FILTER_RESET_CLICKED';

//Offline Paylink Events
export const PAYLINK_SEND_AGAIN_FAILED = 'PAYLINK_SEND_AGAIN_FAILED';
export const PAYLINK_SEND_AGAIN_SUCCEEDED = 'PAYLINK_SEND_AGAIN_SUCCEEDED';
export const PAYLINK_SEND_AGAIN_CLICKED = 'PAYLINK_SEND_AGAIN_CLICKED';
export const CANCEL_OFFLINE_PAYLINK_DETAILS_DRAWER_CLICKED =
	'CANCEL_OFFLINE_PAYLINK_DETAILS_DRAWER_CLICKED';
export const CANCEL_OFFLINE_PAYLINK_MODAL_CLICKED =
	'CANCEL_OFFLINE_PAYLINK_MODAL_CLICKED';
export const PAYLINK_COPY_TRANSACTION_ID_CLICKED =
	'PAYLINK_COPY_TRANSACTION_ID_CLICKED';
export const PAYLINK_FILTER_BUTTON_CLICKED = 'PAYLINK_FILTER_BUTTON_CLICKED';
export const OFFLINE_PAYLINK_FILTER_LINK_STATUS_OPTION_CHECKED =
	'OFFLINE_PAYLINK_FILTER_LINK_STATUS_OPTION_CHECKED';
export const OFFLINE_PAYLINK_SEARCH_BY_LINK_ID =
	'OFFLINE_PAYLINK_SEARCH_BY_LINK_ID';
export const OFFLINE_PAYLINK_SEARCH_BY_EMAIL_ID =
	'OFFLINE_PAYLINK_SEARCH_BY_EMAIL_ID';
export const OFFLINE_PAYLINK_SEARCH_BY_MOBILE_NUMBER =
	'OFFLINE_PAYLINK_SEARCH_BY_MOBILE_NUMBER';
export const PAYLINK_FILTER_APPLY_CLICKED = 'PAYLINK_FILTER_APPLY_CLICKED';

//Online Paylink Events
export const PAYLINK_SHARE_AGAIN_CLICKED = 'PAYLINK_SHARE_AGAIN_CLICKED';
export const PAYLINK_SHARE_AGAIN_SUCCEEDED = 'PAYLINK_SHARE_AGAIN_SUCCEEDED';
export const PAYLINK_SHARE_AGAIN_FAILED = 'PAYLINK_SHARE_AGAIN_FAILED';
export const PAYLINK_LIST_ITEM_CLICKED = 'PAYLINK_LIST_ITEM_CLICKED';
export const PAYLINK_DATE_FILTER_OPENED = 'PAYLINK_DATE_FILTER_OPENED';
export const PAYLINK_DATE_FILTER_CLOSED = 'PAYLINK_DATE_FILTER_CLOSED';
export const PAYLINK_DATE_FILTER_CLICKED = 'PAYLINK_DATE_FILTER_CLICKED';
export const PAYLINK_DATE_SELECTED = 'PAYLINK_DATE_SELECTED';
export const PAYLINK_FILTER_OPENED = 'PAYLINK_FILTER_OPENED';
export const PAYLINK_FILTER_CLOSED = 'PAYLINK_FILTER_CLOSED';
export const PAYLINK_FILTER_SELECTED = 'PAYLINK_FILTER_SELECTED';
export const PAYLINK_LIST_FILTER_REMOVED = 'PAYLINK_LIST_FILTER_REMOVED';
export const PAYLINK_LIST_ITEM_COPIED = 'PAYLINK_LIST_ITEM_COPIED';
export const PAYLINK_SEARCH_INPUT_CLICKED = 'PAYLINK_SEARCH_INPUT_CLICKED';
export const PAYLINK_SEARCH_REQUESTED = 'PAYLINK_SEARCH_REQUESTED';
export const PAYLINK_DETAILS_DRAWER_CANCEL_CLICKED =
	'PAYLINK_DETAILS_DRAWER_CANCEL_CLICKED';
export const PAYLINK_DETAILS_DRAWER_SHARE_CLICKED =
	'PAYLINK_DETAILS_DRAWER_SHARE_CLICKED';
export const PAYLINK_SIDEBAR_COPIED = 'PAYLINK_SIDEBAR_COPIED';
export const PAYLINK_ACTIVATE_CLICKED = 'PAYLINK_ACTIVATE_CLICKED';
export const PAYLINK_ACTIVATION_SUCCESS = 'PAYLINK_ACTIVATION_SUCCESS';
export const PAYLINK_ACTIVATION_FAILED = 'PAYLINK_ACTIVATION_FAILED';
export const PAYLINK_GENERATE_BUTTON_CLICKED =
	'PAYLINK_GENERATE_BUTTON_CLICKED';
export const PAYLINK_CREATE_MODAL_CLOSED = 'PAYLINK_CREATE_MODAL_CLOSED';
export const PAYLINK_SUCCESS_MODAL_CLOSED = 'PAYLINK_SUCCESS_MODAL_CLOSED';

// KYC Events
export const BUSINESS_DETAILS_SECTION_VIEWED =
	'BUSINESS_DETAILS_SECTION_VIEWED';
export const BUSINESS_DETAILS_SUBMITTED = 'BUSINESS_DETAILS_SUBMITTED';
export const BUSINESS_DETAILS_SUBMIT_ERROR = 'BUSINESS_DETAILS_SUBMIT_ERROR';
export const KYC_ACTION_COMPLETED = 'KYC_ACTION_COMPLETED'; // representing TERMINAL_ACTION
export const KYC_SUBMIT_CLICKED = 'KYC_SUBMIT_CLICKED';
export const KYC_POLLING_TIMEDOUT = 'KYC_POLLING_TIMEDOUT';
export const KYC_SUBMIT_FAILED = 'KYC_SUBMIT_FAILED';
export const KYC_PAGE_VIEW = 'KYC_PAGE_VIEW';
export const START_KYC_CLICKED = 'START_KYC_CLICKED';
export const VERIFY_EMAIL_CLICKED = 'VERIFY_EMAIL_CLICKED';

// PG Activation Events
export const OM_DASHBOARD_PAGE = 'OM_DASHBOARD_PAGE';
export const ACTIVATE_PG_CLICKED = 'ACTIVATE_PG_CLICKED';
export const PG_WEB_APP_DETAILS_SECTION_VIEWED =
	'PG_WEB_APP_DETAILS_SECTION_VIEWED';
export const PG_WEB_APP_DETAILS_SECTION_CLOSED =
	'PG_WEB_APP_DETAILS_SECTION_CLOSED';
export const PG_POLICY_DETAILS_SECTION_VIEWED =
	'PG_POLICY_DETAILS_SECTION_VIEWED';
export const PG_POLICY_DETAILS_SECTION_CLOSED =
	'PG_POLICY_DETAILS_SECTION_CLOSED';
export const PG_WEB_APP_DETAILS_SUBMITTED = 'PG_WEB_APP_DETAILS_SUBMITTED';
export const PG_POLICIES_DETAILS_SUBMITTED = 'PG_POLICIES_DETAILS_SUBMITTED';
export const PG_DETAILS_SUBMIT = 'PG_DETAILS_SUBMIT';
export const PG_DETAILS_SUBMIT_SUCCESS = 'PG_DETAILS_SUBMIT_SUCCESS';
export const PG_DETAILS_SUBMIT_ERROR = 'PG_DETAILS_SUBMIT_ERROR';
export const PG_TNC_SECTION_VIEWED = 'PG_TNC_SECTION_VIEWED';
export const PG_SUBMIT_SUCCESS_SECTION_VIEWED =
	'PG_SUBMIT_SUCCESS_SECTION_VIEWED';

// Register page new events
export const REGISTER_VERIFY_BUTTON_CLICKED = 'REGISTER_VERIFY_BUTTON_CLICKED';
export const REGISTER_PROCEED_BUTTON_CLICKED =
	'REGISTER_PROCEED_BUTTON_CLICKED';
export const REGISTER_RESEND_OTP_BUTTON_CLICKED =
	'REGISTER_RESEND_OTP_BUTTON_CLICKED';
export const REGISTER_LOGIN_BUTTON_CLICKED = 'REGISTER_LOGIN_BUTTON_CLICKED';
export const REGISTER_LEAD_FILTER_ONLINE_CLICKED =
	'REGISTER_LEAD_FILTER_ONLINE_CLICKED';
export const REGISTER_LEAD_FILTER_OFFLINE_CLICKED =
	'REGISTER_LEAD_FILTER_OFFLINE_CLICKED';
export const REGISTER_SERVICE_LINE_PAYMENT_GATEWAY_CLICKED =
	'REGISTER_SERVICE_LINE_PAYMENT_GATEWAY_CLICKED';
export const REGISTER_SERVICE_LINE_PAYMENT_LINK_CLICKED =
	'REGISTER_SERVICE_LINE_PAYMENT_LINK_CLICKED';
export const REGISTER_LEAD_FILTER_SELECTION = 'REGISTER_LEAD_FILTER_SELECTION';
export const REGISTER_PHONE_NO_EDITED = 'REGISTER_PHONE_NO_EDITED';
export const REGISTER_EMAIL_ID_EDITED = 'REGISTER_EMAIL_ID_EDITED';
export const REGISTER_WEBSITE_URL_EDITED = 'REGISTER_WEBSITE_URL_EDITED';
export const ONLINE_MERCHANT_CALLBACK_CLICKED =
	'ONLINE_MERCHANT_CALLBACK_CLICKED';
export const REFUND_DETAILS_HELP_CLICKED = 'REFUND_DETAILS_HELP_CLICKED';

//Generate TnC events
export const GENERATE_TNC_POLICIES_PDF_DOWNLOAD =
	'GENERATE_TNC_POLICIES_PDF_DOWNLOAD';
export const GENERATE_TNC_POLICIES_TXT_DOWNLOAD =
	'GENERATE_TNC_POLICIES_TXT_DOWNLOAD';
export const GENERATE_TNC_DOWNLOAD_DROPDOWN_CLICKED =
	'GENERATE_TNC_DOWNLOAD_DROPDOWN_CLICKED';
export const GENERATE_TNC_FIELDS_SCREEN_BACK_PRESS =
	'GENERATE_TNC_FIELDS_SCREEN_BACK_PRESS';
export const GENERATE_TNC_PREVIEW_SCREEN_BACK_PRESS =
	'GENERATE_TNC_PREVIEW_SCREEN_BACK_PRESS';
export const GENERATE_TNC_POLICIES_SELECTED = 'GENERATE_TNC_POLICIES_SELECTED';
export const GENERATE_TNC_FIELDS_FILLED = 'GENERATE_TNC_FIELDS_FILLED';
export const GENERATE_TNC_BUTTON_CLICKED = 'GENERATE_TNC_BUTTON_CLICKED';
export const GENERATE_TNC_CHECKBOX_UNCHECKED =
	'GENERATE_TNC_CHECKBOX_UNCHECKED';
export const GENERATE_TNC_CHECKBOX_CHECKED = 'GENERATE_TNC_CHECKBOX_CHECKED';
export const GENERATE_TNC_PREVIEW_BUTTON_CLICKED =
	'GENERATE_TNC_PREVIEW_BUTTON_CLICKED';
export const GTM_REGISTER_FORM_SUBMIT_CLICK =
	'MERCHANT_REGISTER_FORM_SUBMIT_CLICK';
export const TAKE_NPS_SURVEY_CLICKED = 'TAKE_NPS_SURVEY_CLICKED';
export const NPS_SURVEY_SUBMIT_SUCCESS = 'NPS_SURVEY_SUBMIT_SUCCESS';
export const NPS_SURVEY_SUBMIT_FAILED = 'NPS_SURVEY_SUBMIT_FAILED';
export const MIRA_INIT_SUCCESS = 'MIRA_INIT_SUCCESS';
export const MIRA_INIT_FAILED = 'MIRA_INIT_FAILED';
export const FETCH_MIRA_REPORT_SUCCESS = 'FETCH_MIRA_REPORT_SUCCESS';
export const FETCH_MIRA_REPORT_FAILED = 'FETCH_MIRA_REPORT_FAILED';
export const FETCH_MIRA_SCAN_STATUS_SUCCESS = 'FETCH_MIRA_SCAN_STATUS_SUCCESS';
export const FETCH_MIRA_SCAN_STATUS_FAILED = 'FETCH_MIRA_SCAN_STATUS_FAILED';
export const FOOTER_NAVIGATION_EVENT_NAME = 'FOOTER_NAVIGATION';
export const PG_REGISTER_PRICING_GET_STARTED_BUTTON =
	'PG_REGISTER_PRICING_GET_STARTED_BUTTON';
export const PG_REGISTER_BRAND_TRUST_GET_STARTED_BUTTON =
	'PG_REGISTER_BRAND_TRUST_GET_STARTED_BUTTON';
export const PG_REGISTER_PG_FOOTER_GET_STARTED_BUTTON =
	'PG_REGISTER_PG_FOOTER_GET_STARTED_BUTTON';

// Integration Nudges
export const INTEGERATION_NUDGE_CTA_CLICKED = 'INTEGERATION_NUDGE_CTA_CLICKED';
export const INTEGERATION_NUDGE_SHOWN = 'INTEGERATION_NUDGE_SHOWN';
export const NUDGE_MERCHANT_STATE_EMPTY = 'NUDGE_MERCHANT_STATE_EMPTY';
